<div>
   <fa-icon
      *ngIf="!hideIcon"
      [icon]="statusInfo.id === offline ? donutIcon : statusIcon"
      [samwebUserStatusClass]="statusInfo"
      [fixedWidth]="true"
   ></fa-icon>
   {{ statusName }}
</div>
